import { defineMessages } from "react-intl";

export const messages = defineMessages({
  recentlyUsedDates: {
    id: "ari.management.recentlyUsedDates",
    defaultMessage: "Recently used dates"
  }
});